<template>
    <div>
        <div class="content-left border-left-3" >
            <ProjectTree
                @tree-node-click="onTreeNodeClick_1"/>
        </div>
        <div class="content-right">
            <!-- 工单列表 -->
            <ViewTicketList ref="ticketList"/>

            <NewTicketDialog ref="newTicketDialog"/>
        </div>
    </div>
</template>

<script>
import CacheUtil from '@/assets/utils/CacheUtil';

export default {
    name: 'ProjectIndex',

    methods: {
        onTreeNodeClick_1(data) {
            localStorage.setItem(CacheUtil.ProjectId, data.id);
            this.$refs.ticketList.queryTicketList_2(1);
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/ProjectIndex.vue